import { Col, List, Row } from "antd";
import {
  InputField,
  PhoneInput,
  SubmitButton,
  TextComponent,
  TextareaField,
} from "../../../components";
import styles from "./EditSubVendor.module.css";
import { LocIcon } from "../../../components/icons/Icons";
import Dropdown from "../../../components/dropdowns/Dropdown";
import { useLocation, useNavigate } from "react-router-dom";
import { IoIosMail } from "react-icons/io";
import { BsTelephoneFill } from "react-icons/bs";
import { memo, useRef, useState } from "react";
import addDoc from "../../../assets/staticImages/addDoc.png";
import addImage from "../../../assets/staticImages/addImage.png";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { RiDeleteBinLine } from "react-icons/ri";
import { IoAddCircle, IoCloseCircle, IoCloseSharp } from "react-icons/io5";
import { BiPlus, BiSolidMinusCircle } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { showAlert } from "../../../Store/Actions/GeneralActions";
import AutoCompleteInput from "../../../components/auntoCompleteInput/AutoCompleteInput";
import { VendorMiddleware } from "../../../Store/Middlewares/VendorMiddleware";

const inputs = {
  label: "Add Social Links",
  type: "text",
  link: "https://www.instagram.com/Trish",
  multiple: true,
  list: [{ link: "https://www.instagram.com/Trish", value: "" }],
};

const servicesArr = [
  "Photography",
  "Portrait Sessions",
  "Bridal Photography",
  "Product Photography",
  "Videography",
];

const RenderDoc = memo(({ docs, i }) => {
  let document = docs.doc
    ? { uri: `https://www.bestdayever.me/api/downloadFile?path=${docs.doc}` }
    : docs;
  return (
    <DocViewer
      documents={[document]}
      pluginRenderers={DocViewerRenderers}
      className={styles.pdfView}
      config={{
        header: { disableHeader: true },
        pdfVerticalScrollByDefault: false,
      }}
      language="en"
    />
  );
});

const RenderDocView = memo(({ docs, setDocs, i, doc }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  function handleDropdown(e) {
    e.stopPropagation();
    setDropdownOpen((prev) => !prev);
  }
  const deleteDoc = (id) => {
    console.log("iddddddddddddddddddd", id);
    const arr = docs.filter((data) => {
      console.log(id != data.id);
      if (id != data.id) {
        return data;
      }
    });
    setDocs(arr);
    setDropdownOpen(false);
  };

  return (
    <Col className={styles.pdfCol} key={docs[i].id.toString()}>
      <Row style={{ justifyContent: "flex-end" }}>
        <TextComponent textClass={styles.dropdownBtn} onClick={handleDropdown}>
          ...
        </TextComponent>
      </Row>
      {dropdownOpen && (
        <Row className={styles.dropdown}>
          <Col>
            <Row
              className={styles.dropdownItem}
              onClick={() => deleteDoc(docs[i].id)}
            >
              <RiDeleteBinLine fontSize="1.1rem" />
              <TextComponent textClass={styles.dropdownText}>
                Delete
              </TextComponent>
            </Row>
          </Col>
        </Row>
      )}
      <RenderDoc docs={doc} i={i} />
    </Col>
  );
});

const EditSubVendor = () => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  let data = state?.data;
  let name = data?.name;
  let parts = name.split(" ");
  let fName = parts.shift(); // Paul
  let lName = parts.join(" "); // Steve Panakkal
console.log('data',data)
  const [firstName, setfirstName] = useState(fName ? fName : "");
  const [lastName, setlastName] = useState(lName ? lName : "");
  const [email, setEmail] = useState(data?.email ? data?.email : "");
  const [category, setCategory] = useState();
  const [contactNo, setContactNo] = useState(
    data?.contact_no ? data?.contact_no : ""
  );
  const [currentLocation, setCurrentLocation] = useState();
  const [address, setAddress] = useState(data?.address ? data?.address : "");
  const [lat, setLat] = useState(data?.lat ? data?.lat : "");
  const [lng, setLng] = useState(data?.lng ? data?.lng : "");
  const [socialLinks, setSocialLinks] = useState(data?.sociallink);
  const [serviceText, setServiceText] = useState(
    data?.service ? data?.service : ""
  );
  const [about, setAbout] = useState(
    data?.about_the_vendor ? data?.about_the_vendor : ""
  );
  const [docs, setDocs] = useState(data?.documents ? [...data?.documents] : []);
  const [staffImages, setStaffImages] = useState(data?.photos ? [...data?.photos] : []);
  const [link, setLink] = useState("");

  const SubVendorCategories = useSelector(
    (state) => state?.GeneralReducer?.GeneralTypes?.servicecategory
  );

  const docRef = useRef();
  const imageRef = useRef();

  const urlRegex =
    /(^https?|^http):\/\/www\.?[a-zA-Z0-9.-]+(?:\.[a-zA-Z]{2,})+(?:\/[^\s]*)?$/i;
  console.log("docs", docs);
  const handleClick = () => {
    docRef.current.value = "";
    docRef.current.click();
  };
  const navigate = useNavigate();

  //   const handleAdd = () => {
  //     let link = socialLinks?.list[socialLinks?.list?.length - 1]?.value;
  //     if (urlRegex.test(link)) {
  //       let arr = link?.split(".");
  //       let domain = arr[arr.length - 2];
  //       linkList?.push({ link: link, platform: domain });
  //       setSocialLinks((prev) => ({
  //         ...prev,
  //         list: [...prev.list, { placeholder: "Social Link", value: "" }],
  //       }));
  //     } else {
  //       dispatch(
  //         showAlert({
  //           title: "Link",
  //           message: "Please enter valid social link",
  //           type: "Error",
  //           status: 400,
  //         })
  //       );
  //     }
  //   };

  //   const handleChange = (e, i) => {
  //     setSocialLinks((prev) => ({
  //       ...prev,
  //       list: prev.list.map((listItem, index) => {
  //         if (index === i) {
  //           return { ...listItem, value: e.target.value };
  //         } else {
  //           return listItem;
  //         }
  //       }),
  //     }));
  //   };

  //   const handleRemove = (i) => {
  //     setSocialLinks((prev) => ({
  //       ...prev,
  //       list: prev.list.filter((listItem, index) => index !== i),
  //     }));
  //     linkList?.splice(i, 1);
  //   };
  const handleAddLink = () => {
    if (urlRegex.test(link)) {
      let array = link.split(".");
      let domain = array[array.length - 2];
      socialLinks.push({ link: link, platform: domain });
      console.log("SocialLinks", socialLinks);
      setLink("");
      // setrefreshList(!refreshList);
    } else {
      dispatch(
        showAlert({
          title: "Link",
          message: "Please enter valid social link",
          type: "Error",
          status: 400,
        })
      );
    }
    // setSocialLinks([link, ...SocialLinks]);
    // setLink("");
  };

  const handleRemLink = (i) => {
    let links = socialLinks.filter((item, index) => i != index);
    setSocialLinks(links);
  };

  // const addServices = () => {
  //   setServices((prev) => [...prev, serviceText]);
  //   setServiceText("");
  // };

  // const removeService = (i) => {
  //   setServices((prev) => prev.filter((text, index) => i !== index));
  // };
  const onPressCreate = () => {
    if (
      //   !category ||
      !firstName ||
      !lastName ||
      !email ||
      !contactNo ||
      // !currentLocation ||
      !about ||
      !serviceText
    ) {
      dispatch(
        showAlert({
          title: "Add sub vendor",
          message: "All fields are mandatory.",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) == false
    ) {
      dispatch(
        showAlert({
          title: "Add sub vendor",
          message:
            "Please enter a valid email address in the correct format (e.g., example@example.com)",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else if (socialLinks?.length == 0) {
      dispatch(
        showAlert({
          title: "Add sub vendor",
          message: "Add social link.",
          type: "Error",
          status: 400,
        })
      );
      return;
    }
    // else if (docs?.length == 0) {
    //   dispatch(
    //     showAlert({
    //       title: "Add sub vendor",
    //       message: "Add document.",
    //       type: "Error",
    //       status: 400,
    //     })
    //   );
    //   return;
    // }
    else {
      let subVendorData = {
        user_id: data?.id,
        service_category: category?.id
          ? category?.id
          : data?.service_category_id,
        first_name: firstName,
        last_name: lastName,
        email,
        contact: contactNo,
        address: currentLocation?.address ? currentLocation?.address : address,
        lat: currentLocation?.lat ? currentLocation?.lat : lat,
        lng: currentLocation?.lng ? currentLocation?.lng : lng,
        socialLinks: socialLinks,
        about,
        service: serviceText,
        documents: docs,
        images: staffImages,
      };
      dispatch(VendorMiddleware.updateStaffProfile(subVendorData))
        .then(() => {
          navigate(-1);
          navigate("/profile/subVendors");
        })
        .catch((err) => console.log(err));
    }
  };

  const handleImageClick = () => {
    imageRef.current.click();
  };

  const deleteImage = (index) => {
    let imgObjCpy = [...staffImages];
    imgObjCpy.splice(index, 1);
    setStaffImages(imgObjCpy);
  };

  const renderImages = (item, index) => {
    return (
      <div className={styles.listItem}>
        <img src={item?.image} />

        <BiSolidMinusCircle
          className={styles.icon}
          onClick={() => deleteImage(index)}
        />
      </div>
    );
  };
  return (
    <>
      <Row>
        <TextComponent textClass={styles.heading}>
          Personal Information
        </TextComponent>
      </Row>
      <Row className={styles.row} justify={"space-between"} gutter={16}>
        <Col xs={24} md={12}>
          <InputField
            label="First Name"
            placeholder="Trish"
            value={firstName}
            onChange={(e) => setfirstName(e.target.value)}
          />
        </Col>
        <Col xs={24} md={12}>
          <InputField
            label="Last Name"
            placeholder="James"
            value={lastName}
            onChange={(e) => setlastName(e.target.value)}
          />
        </Col>
        <Col xs={24} md={12}>
          <InputField
            label="Email"
            type="email"
            rightIcon={<IoIosMail size={18} color="var(--primary-color)" />}
            placeholder="email@bestdayever.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Col>
        <Col xs={24} md={12}>
          <Dropdown
            stylesClass={styles.dropdownClass}
            placeholder="Select category"
            label="Category"
            object={SubVendorCategories}
            onChange={(e) => setCategory(e)}
            selectedValue={data?.service_category_name}
          // options={[
          //   { value: "Florist", option: "Florist" },
          //   { value: "Catering", option: "Catering" },
          //   { value: "Transportation", option: "Transportation" },
          //   { value: "Photos & Videography", option: "Photos & Videography" },
          // ]}
          />
        </Col>
        <Col xs={24} md={12}>
          {/* <InputField
            label="Contact Number"
            type="number"
            rightIcon={
              <BsTelephoneFill size={18} color="var(--primary-color)" />
            }
            placeholder="+1 (234) 456-4567"
          /> */}
          <PhoneInput
            label="Contact Number"
            placeholder="+1 (234) 456-4567"
            value={contactNo}
            onChange={(e) => setContactNo(e)}
          />
        </Col>
        <Col xs={24} md={12}>
          <AutoCompleteInput
            label={"Address"}
            placeholder={address ? address : "Enter Address"}
            address={currentLocation?.address}
            onSelectPlace={(place) => {
              let currentLocation = {
                lat: place?.geometry?.location?.lat(),
                lng: place?.geometry?.location?.lng(),
                address: place?.formatted_address,
              };
              setCurrentLocation(currentLocation);
            }}
          />
        </Col>
        <Col xs={24} md={12}>
          <>
            <TextComponent
              text={"Add Social Links"}
              textClass={styles.sub_heading}
            />
            {socialLinks?.map(
              (item, index) => (
                console.log("item", item),
                (
                  <InputField
                    value={item?.link}
                    placeholder="Facebook.com/Trish"
                    // onChange={(e)=>{
                    //   let arr = [...SocialLinks]
                    //   arr[index].link= e.target.value;
                    //   setSocialLinks(arr)
                    // }}
                    disabled
                    rightIcon={
                      <IoCloseCircle
                        size={30}
                        className={styles.closeIcon}
                        onClick={() => handleRemLink(index)}
                      />
                    }
                  />
                )
              )
            )}
            <InputField
              value={link}
              placeholder="Facebook.com/Trish"
              onChange={(e) => setLink(e.target.value)}
              // labelClass={styles.label}
              // styles={styles.input}
              rightIcon={
                <IoAddCircle
                  size={30}
                  className={styles.addIcon}
                  onClick={handleAddLink}
                />
              }
            />
          </>
          {/* {socialLinks.list.map((inp, i) => (
            <Row
              style={{
                justifyContent: "space-between",
                alignItems: "flex-end",
              }}
            >
              <Col xs={18} sm={20} md={19} lg={21} xl={21}>
                <InputField
                  label={i === 0 && socialLinks.label}
                  placeholder={inp.link}
                  disabled={i !== socialLinks.list.length - 1}
                  value={inp.value}
                  onChange={(e) => handleChange(e, i)}
                />
              </Col>
              <Col
                xs={5}
                sm={4}
                md={4}
                lg={3}
                xl={2}
                className={styles.addBtnCol}
              >
                <div
                  className={
                    i === socialLinks.list.length - 1
                      ? styles.addBtn
                      : styles.closeBtn
                  }
                >
                  {i === socialLinks.list.length - 1 ? (
                    <BiPlus onClick={() => handleAdd()} />
                  ) : (
                    <IoCloseSharp onClick={() => handleRemove(i)} />
                  )}
                </div>
              </Col>
            </Row>
          ))} */}
        </Col>
        <Col xs={24} md={12}>
          <InputField
            label="Add Services"
            value={serviceText}
            // rightIcon={<BiPlus size={18} color="var(--primary-color)" />}
            placeholder="Photography"
            // onRightIconPress={(e) => {
            //   if (serviceText) {
            //     addServices();
            //   }
            // }}
            onChange={(e) => {
              setServiceText(e.target.value);
            }}
          />
          {/* {services?.length > 0 && (
            <Row gutter={[8, 16]} className={styles.servicesRow}>
              {services?.map((service, i) => (
                <Col xs={22} sm={10} md={22} lg={11} offset={1}>
                  <Row className={styles.serviceCol}>
                    <TextComponent textClass={styles.serviceText}>
                      {service}
                    </TextComponent>
                    <IoCloseSharp
                      color="var(--primary-color)"
                      size={20}
                      style={{ cursor: "pointer" }}
                      onClick={() => removeService(i)}
                    />
                  </Row>
                </Col>
              ))}
            </Row>
          )} */}
        </Col>
      </Row>
      <Col xs={24} md={12}>
        <TextareaField
          label="About"
          placeholder="Write about yourself"
          rows={6}
          value={about}
          onChange={(e) => setAbout(e.target.value)}
        />
      </Col>
      <TextComponent
        textClass={styles.documentsHeading}
        text={"Add Documents"}
      />
      <Row>
        {docs.map((doc, i) => {
          return (
            <>
              <RenderDocView docs={docs} doc={doc} i={i} setDocs={setDocs} />
            </>
          );
        })}
      </Row>
      <Row>
        <Col className={styles.imgCol} onClick={handleClick}>
          <img src={addDoc} className={styles.image} alt="docSelect" />
          <input
            type="file"
            accept=".pdf"
            multiple
            onChange={(el) =>
              el.target.files?.length &&
              setDocs([
                ...docs,
                ...Array.from(el.target.files).map((file, i) => ({
                  file: file,
                  uri: window.URL.createObjectURL(file),
                  fileName: file.name,
                  id: `${docs?.length + i + 12}`,
                })),
              ])
            }
            ref={docRef}
            className={styles.displayNone}
          />
        </Col>
        <Col className={styles.imgCol} >
          <img onClick={handleImageClick} src={addImage} className={styles.image} alt="imageSelect" />
          <input
            type="file"
            accept="image/*"
            multiple
            onChange={(e) => {
              e.preventDefault();
              setStaffImages([...staffImages, ...e.target.files]);
            }}
            ref={imageRef}
            style={{ display: "none" }}
          />
          {staffImages?.length > 0 &&
            <List
              className={styles.list}
              grid={{ gutter: 16 }}
              itemLayout="horizontal"
              dataSource={staffImages}
              renderItem={renderImages}
            />
          }
        </Col>
      </Row>
      <Row>
        <Col xs={24} md={10} lg={8}>
          <SubmitButton
            title={"Done"}
            btnClass={styles.solidBtn}
            onClick={onPressCreate}
          />
        </Col>
      </Row>
    </>
  );
};

export default EditSubVendor;
